import log2 from "../../utils/log2";

let recorder = null;

export const getRecorder = () => {
    if (!recorder) recorder = VoiceRecorder();
    return recorder;
};

const log = log2("VoiceRecordersdk");

// Tarayicilar ayni bicimi kaydetmiyor: Chrome/Firefox webm/opus, Safari mp4.
// Kaydin gercek bicimi ogrenilip oyle etiketleniyor; onceden her kayit
// "audio/wav" olarak paketlenip "mp3" diye yukleniyordu ve dosya acilmiyordu.
const ADAYLAR = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/ogg;codecs=opus", "audio/ogg"];

const UZANTILAR = { webm: "webm", mp4: "m4a", ogg: "ogg", wav: "wav", mpeg: "mp3" };

export const uzantiOf = (mime) => {
    const tur = String(mime || "").split(";")[0].split("/")[1] || "";
    return UZANTILAR[tur] || "webm";
};

const desteklenenTip = () => {
    if (typeof MediaRecorder === "undefined") return "";
    if (typeof MediaRecorder.isTypeSupported !== "function") return "";
    for (const tip of ADAYLAR) {
        if (MediaRecorder.isTypeSupported(tip)) return tip;
    }
    return "";
};

const VoiceRecorder = () => {
    let stream = null;
    let mediaRecorder = null;
    let chunks = [];

    const getStream = async () => {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const mimeType = desteklenenTip();
        mediaRecorder = mimeType ? new MediaRecorder(stream, { mimeType }) : new MediaRecorder(stream);
    };

    const serbestBirak = () => {
        if (!stream) return;
        for (const track of stream.getTracks()) {
            track.enabled = false;
            track.stop();
        }
    };

    // cb: kayit basladiginda cagrilir. hataCb: mikrofon izni yoksa ya da
    // cihaz acilamazsa cagrilir; eskiden hata yutuluyor, arayuz "kaydediyor"
    // gorunumunde asili kaliyordu.
    const start = async (cb, hataCb) => {
        log("start");
        try {
            if (!mediaRecorder) await getStream();
            if (mediaRecorder.state === "recording") return;
            chunks = [];
            // Veri dinleyicisi kayit boyunca bagli: parcalar birikirken yakalaniyor.
            mediaRecorder.ondataavailable = (e) => {
                if (e.data && e.data.size) chunks.push(e.data);
            };
            mediaRecorder.onstart = (e) => cb && cb(e);
            mediaRecorder.start();
        } catch (e) {
            log.error("mikrofon acilamadi", e);
            serbestBirak();
            recorder = null;
            if (hataCb) hataCb(e);
        }
    };

    const stop = (cb) => {
        log("stop");
        if (!mediaRecorder || mediaRecorder.state !== "recording") return;
        const mimeType = mediaRecorder.mimeType || desteklenenTip() || "audio/webm";
        mediaRecorder.onstop = () => {
            const blob = new Blob(chunks, { type: mimeType });
            chunks = [];
            if (cb) cb(blob);
            serbestBirak();
            recorder = null;
        };
        mediaRecorder.stop();
    };

    VoiceRecorder.start = start;
    VoiceRecorder.stop = stop;
    VoiceRecorder.mediaRecorder = mediaRecorder;
    VoiceRecorder.stream = stream;

    return VoiceRecorder;
};



// WEBPACK FOOTER //
// ./src/components/util/voiceRecorder.js